import "../styles/ExperincePage.css";
import { useEffect, useState } from "react";
import AOS from "aos";
import ExperienceCard from "../components/ExperienceCard";
import axios from "axios";
import Loader from "../components/Loader";

interface Companies {
  id: number;
  position: string;
  company: string;
  startdate: string;
  duties: string[];
  link: string;
}

const ExperiencePage = () => {
  const [companies, setCompanies] = useState<Companies[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [backend] = useState<string>(
    "https://personal-portfolio-backend-waf6.vercel.app"
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 500, // Animation duration in milliseconds
      offset: 200, // Trigger animation when 200px from the top
      easing: "ease-in-out", // Animation easing function
      once: true, // Animation runs only once
      mirror: true, // Animation plays again when scrolling back up
    });

    const fetchCompanies = async (
      retryCount = 0,
      retryLimit = 60,
      retryDelay = 2000
    ) => {
      try {
        const response = await axios.get(backend + "/content/experiences.json");
        if (response.data) {
          setCompanies(response.data);
          setLoading(false); // Stop retrying after success
        } else {
          setError("No experience found.");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching experience:", error);
        if (retryCount < retryLimit) {
          setTimeout(() => fetchCompanies(retryCount + 1), retryDelay);
        } else {
          setError("Failed to fetch experience. Please try again later...");
          setLoading(false);
        }
      }
    };

    fetchCompanies();
  }, [backend]);

  return (
    <div className="experincePage">
      <div className="title" data-aos="fade-up">
        Experience
      </div>
      {error && <p className="message">{error}</p>}
      {loading ? (
        <div className="companiesLoader" data-aos="fade-up">
          <Loader />
        </div>
      ) : (
        !error && (
          <div className="experienceGrid">
            <div className="experiencePresent" data-aos="zoom-in">
              Present
            </div>
            {companies.map((company, index) => (
              <ExperienceCard
                key={company.id}
                id={company.id}
                expPosition={company.position}
                expCompany={company.company}
                expDuties={company.duties}
                expDate={company.startdate}
                expLink={company.link}
                index={index}
              />
            ))}
            <div className="experienceTimeline" data-aos="zoom-in" />
          </div>
        )
      )}
    </div>
  );
};

export default ExperiencePage;
